export default __webpack_public_path__ + "static/media/gazpacho.0e6a0e50.jpg";